import { SchemaProperty, SchemaPerspective } from 'types/schema';



/**
 * Convert a Perspective object to a SchemaProperty object
 * so it can be passed to generateYupValidationSchema.
 */
export default function perspectiveToSchemaProperty(
  perspective: SchemaPerspective
): SchemaProperty {
  return {
    name: perspective.system_name,
    label: perspective.label,
    type: 'string', // or 'object' / 'array' / etc. depending on your real structure
    required: perspective.required || false,
    hidden: false,
    read_only: false,
    defined_on: 'node',
    is_inherited: perspective.global ?? false, // fallback to false if undefined
    inherited_from_schema: 'some-schema-id', // do we need it?
    default_value: '',
    rules: [],
  };
}
